const SUBCOMMANDS = new Set([
  "build", "run", "test", "seed", "compile", "snapshot", "run-operation", "generate",
]);

const tokenize = (command: string) => {
  const parts = command.split(/(\s+)/);
  return parts.map((token, i) => {
    if (token === "dbt") {
      return <span key={i} className="al-text-purple-600 al-font-semibold">{token}</span>;
    }
    if (SUBCOMMANDS.has(token)) {
      return <span key={i} className="al-text-blue-600 al-font-semibold">{token}</span>;
    }
    if (token.startsWith("--")) {
      return <span key={i} className="al-text-orange-600">{token}</span>;
    }
    return <span key={i}>{token}</span>;
  });
};

export const DbtCommandHighlight = ({ command }: { command: string }) => (
  <span className="al-font-mono al-text-sm">{tokenize(command)}</span>
);
